import { useEffect, useState } from "react";

// A slim bar pinned to the bottom of the screen once the reader has scrolled
// past the reading, hidden again while the full offer is on screen. It takes
// them to the offer, not to checkout, so they still see what they're buying.

/** Whether the bar should show, from where the reading ends and where the offer sits. */
export function shouldShowSticky(readingRect, offerRect, viewportHeight) {
  if (!readingRect || !offerRect) return false;
  const pastReading = readingRect.bottom < viewportHeight * 0.6;
  const offerOnScreen = offerRect.top < viewportHeight && offerRect.bottom > 0;
  return pastReading && !offerOnScreen;
}

export default function StickyOffer({ readingRef, offerRef, price, onClick }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let frame = 0;
    function update() {
      frame = 0;
      setShow(shouldShowSticky(
        readingRef.current?.getBoundingClientRect(),
        offerRef.current?.getBoundingClientRect(),
        window.innerHeight,
      ));
    }
    function onScroll() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [readingRef, offerRef]);

  return (
    <div aria-hidden={!show}
      className={`fixed inset-x-0 bottom-0 z-20 border-t border-orange-200 bg-white/95 px-4 py-3 shadow-[0_-6px_20px_rgba(0,0,0,0.08)] backdrop-blur-sm transition-transform duration-300 ${
        show ? "translate-y-0" : "pointer-events-none translate-y-full"
      }`}>
      <div className="mx-auto flex max-w-md items-center gap-3">
        <div className="min-w-0 flex-1 leading-tight">
          <p className="text-sm font-semibold text-gray-900">Your full report · {price}</p>
          <p className="text-xs text-gray-600">14-day full refund</p>
        </div>
        <button type="button" onClick={onClick} tabIndex={show ? 0 : -1}
          className="shrink-0 rounded-xl bg-gradient-to-r from-orange-500 to-orange-600 px-4 py-2.5 text-sm font-semibold text-white shadow hover:from-orange-600 hover:to-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2">
          Unlock my report
        </button>
      </div>
    </div>
  );
}
